interface IAvailableInBadgeProps {
  isCovered: boolean;
  availableIn?: string;
}

const AvailableInBadge = ({isCovered, availableIn}: IAvailableInBadgeProps) => {

  const getBadge = () => {
    if (!isCovered && availableIn ) {
      return (
        <div className="label label-muted rounded-circle text-bold">
          <span className='rioglyph rioglyph-time-alt margin-right-5 text-color-dark'></span>
          <span className="text-bold  text-color-dark">{availableIn}</span>
        </div>
      )
    }

    if(isCovered) {
      return (
        <div className="label label-success rounded-circle">
          <span className="rioglyph rioglyph-ok margin-right-5">
          </span>
          <span>Troca disponível</span>
        </div>
      )
    }

    return '-'
  }

  return getBadge()
}

export default AvailableInBadge;